// extracted by mini-css-extract-plugin
module.exports = {"container":"list-module__container--34nWl","key":"list-module__key--FD_Dg","value":"list-module__value--3i2c9"};